import React, { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import api from "../components/customAxios/Axios";
import { useToast } from "../components/toast";
import { useLoader } from "../context/loaderContext";
import { AiOutlineEye, AiOutlineEyeInvisible } from "react-icons/ai";
import Tooltip from "@/components/Tooltip";
import authPhoto from "@/assets/auth.webp"
import logo2 from "@/assets/talentick.ai.webp";
import logo from "@/assets/talentickaiwhite.webp";
import { Link } from "react-router-dom";
const SetupUserAccount = () => {
	const params = useParams();

	const { setLoading } = useLoader();
	const toast = useToast();
	const navigate = useNavigate();
	const [password, setPassword] = useState("");
	const [firstName, setFirstName] = useState("");
	const [lastName, setLastName] = useState("");
	const [tempPassword, setTempPassword] = useState("");
	const [confirmPassword, setConfirmPassword] = useState("");
	const [showPassword, setShowPassword] = useState(false);
	const [showNewPassword, setNewShowPassword] = useState(false);
	const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
		event.preventDefault();
		if (password !== confirmPassword) {
			toast.error({
				title: "Error",
				description: "Password and Confirm Password do not match. Please Try Again.",
				duration: 5000,
				open: true,
				status: "error",
			});
			return;
		}
		try {
			setLoading(true);
			const res = await api.post(
				"complete-account-setup",
				{
					first_name: firstName,
					last_name: lastName,
					new_password: password,
					temp_password: tempPassword,
				},
				{
					headers: {
						Authorization: `Bearer ${params.token}`,
					},
				}
			);

			if (res.status === 200) {
				setLoading(false);
				navigate("/login");
			}
		} catch (err: any) {
			setLoading(false);

			toast.error({
				title: "Error",
				description: err.response?.data?.error || err.response?.data?.message || "An error occurred.",
				duration: 5000,
				open: true,
				status: "error",
			});
		}
	};
	return (
		<div className="mx-auto flex flex-col md:flex-row items-center gap-8 bg-white">
			{/* Mobile Logo */}
			<div className="w-full block md:hidden mb-6">
				<Link to="/" className="flex gap-2 items-center fixed top-10">
					<svg width="20" height="18" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
						<path
							d="M10.0154 0.733154L4.23065 6.51518C3.93728 6.79466 3.93728 7.23137 4.23065 7.51085L10.0155 13.2928"
							stroke="#7F7F7F"
							strokeMiterlimit="2.613"
							strokeLinecap="round"
							strokeLinejoin="round"
						/>
					</svg>
					<img src={logo2} className="h-5" alt="Logo" />
				</Link>
			</div>

			{/* Left Side - Image and Text */}
			<div className="relative w-[55%] h-screen hidden md:block">
				<img
					src={authPhoto}
					alt="Background"
					className="w-full h-screen object-cover shadow-md"
				/>
				<div className="absolute inset-0 opacity-40 h-screen bg-[#32413D]"></div>

				{/* Logo */}
				<Link to="/">
					<img
						src={logo}
						className="absolute top-8 left-8 max-h-10 cursor-pointer z-50"
						alt="Logo"
					/>
				</Link>

				{/* Centered Text Box */}
				<div className="absolute inset-0 flex flex-col items-center justify-center px-8">
					<div className="bg-white/30 backdrop-blur-[70px] rounded-lg p-8 md:p-10 w-full max-w-[650px] text-white">
						<h2 className="text-2xl lg:text-5xl font-bold mb-4">
							Smarter Hiring Made Simple
						</h2>
						<p className="text-sm lg:text-lg font-light">
							Experience a new era of recruitment with talentick.ai, where AI simplifies hiring automatically generating assessments, scoring resumes, and helping you find the right candidates faster. Get started today!
						</p>
					</div>
				</div>

				{/* Bottom text */}
				<div className="absolute bottom-8 w-full text-center text-white text-sm lg:text-base font-light">
					Browse through resumes and find the right candidate
				</div>
			</div>

			{/* Right Side - Setup Account Form */}
			<div className="w-full md:w-[40%] h-screen overflow-y-auto md:px-0 px-4 py-8">
				<div className="flex flex-col items-center justify-center min-h-full">
					<div className="w-full">
						<h2 className="text-2xl md:text-3xl font-bold text-center text-zinc-800 mb-6">
							Setup Your Account
						</h2>

						<form className="space-y-5" method="POST" onSubmit={handleSubmit}>
							<div className="grid md:grid-cols-2 gap-4">
								<div>
									<label className="block text-sm font-medium text-zinc-700 dark:text-zinc-300 mb-2">
										First Name <span className="text-red-500">*</span>
									</label>
									<input
										onChange={(e) => setFirstName(e.target.value)}
										name="first_name"
										type="text"
										required
										placeholder="First Name"
										className="w-full border rounded-lg p-3 text-zinc-700 dark:text-zinc-300 bg-transparent "
									/>
								</div>
								<div>
									<label className="block text-sm font-medium text-zinc-700 dark:text-zinc-300 mb-2">
										Last Name <span className="text-red-500">*</span>
									</label>
									<input
										onChange={(e) => setLastName(e.target.value)}
										name="last_name"
										type="text"
										required
										placeholder="Last Name"
										className="w-full border rounded-lg p-3 text-zinc-700 dark:text-zinc-300 bg-transparent "
									/>
								</div>
							</div>

							<div className="relative">
								<label className="block text-sm font-medium text-zinc-700 dark:text-zinc-300 mb-2">
									Temporary Password{" "}
								</label>
								<div className="relative">
									<input
										type={showPassword ? "text" : "password"}
										value={tempPassword}
										onChange={(e) => setTempPassword(e.target.value)}
										className="w-full border rounded-lg p-3 text-zinc-700 dark:text-zinc-300 bg-transparent  pr-10"
										placeholder="Password"
										required
									/>
									<button
										type="button"
										onClick={() => setShowPassword(!showPassword)}
										className="absolute inset-y-0 right-3 flex items-center text-zinc-500 hover:text-zinc-700 dark:hover:text-zinc-400"
									>
										{showPassword ? (
											<AiOutlineEyeInvisible size={20} />
										) : (
											<AiOutlineEye size={20} />
										)}
									</button>
								</div>
							</div>
							<div className="relative">
								<label className="block text-sm font-medium text-zinc-700 dark:text-zinc-300 mb-2">
									Password{" "}
									<Tooltip position="right">
										<ul className=" list-disc pl-4">
											<li>At least 6 characters long</li>
											<li>At least one uppercase letter</li>
											<li>At least one number</li>
											<li>At least one special character (@$!%*?&)</li>
										</ul>
									</Tooltip>
								</label>
								<div className="relative">
									<input
										type={showNewPassword ? "text" : "password"}
										id="password"
										autoComplete="password"
										value={password}
										pattern="(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{6,}"
										onChange={(e) => setPassword(e.target.value)}
										onInvalid={(e) =>
											(e.target as HTMLInputElement).setCustomValidity(
												"Password does not meet the required criteria. Please ensure it meets all the specified requirements."
											)
										}
										onInput={(e) =>
											(e.target as HTMLInputElement).setCustomValidity("")
										}
										className="w-full border border-gray-300 rounded-lg py-3 px-4 text-zinc-700 bg-transparent focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
										placeholder="Password"
										required
									/>
									<button
										type="button"
										onClick={() => setNewShowPassword(!showNewPassword)}
										className="absolute inset-y-0 right-3 flex items-center text-zinc-500 hover:text-zinc-700 dark:hover:text-zinc-400"
									>
										{showNewPassword ? (
											<AiOutlineEyeInvisible size={20} />
										) : (
											<AiOutlineEye size={20} />
										)}
									</button>
								</div>
							</div>

							<div>
								<label className="block text-sm font-medium text-zinc-700 dark:text-zinc-300 mb-2">
									Confirm Password <span className="text-red-500">*</span>
								</label>
								<input
									onChange={(e) => setConfirmPassword(e.target.value)}
									name="confirm_password"
									type="password"
									autoComplete="new-password"
									required
									placeholder="Confirm Password"
									className="w-full border rounded-lg p-3 text-zinc-700 dark:text-zinc-300 bg-transparent "
								/>
							</div>

							<button
								type="submit"
								className="w-full bg-[#162D3A] text-white font-semibold py-3 px-4 rounded-lg hover:bg-[#0e1c24] transition-colors duration-200 flex items-center justify-center"
							>
								Register
							</button>
						</form>
					</div>
				</div>
			</div>
		</div>
	);
};

export default SetupUserAccount;
